import React, { useState, useEffect, useRef, useMemo } from 'react';
import Navbar from '../Navbar/Navbar';
import { State, City } from 'country-state-city';
import './Styles.css';

import groupOnline1 from '../../assets/fellowships/group_online_1.png';
import groupOnline2 from '../../assets/fellowships/group_online_2.png';
import groupOnline3 from '../../assets/fellowships/group_online_3.png';
import groupOnline4 from '../../assets/fellowships/group_online_4.png';
import groupPhysical1 from '../../assets/fellowships/group_physical_1.png';
import groupPhysical2 from '../../assets/fellowships/group_physical_2.png';
import groupPhysical3 from '../../assets/fellowships/group_physical_3.png';
import groupPhysical4 from '../../assets/fellowships/group_physical_4.png';
import groupPhysical5 from '../../assets/fellowships/group_physical_5.png';
import groupPhysical6 from '../../assets/fellowships/group_physical_6.png';
import groupPhysical7 from '../../assets/fellowships/group_physical_7.png';
import groupPhysical8 from '../../assets/fellowships/group_physical_8.png';
import groupPhysical9 from '../../assets/fellowships/group_physical_9.png';
import groupPhysical10 from '../../assets/fellowships/group_physical_10.png';
import groupPhysical11 from '../../assets/fellowships/group_physical_11.png';
import groupPhysical12 from '../../assets/fellowships/group_physical_12.png';
import groupPhysical13 from '../../assets/fellowships/group_physical_13.png';

const API_BASE = process.env.NODE_ENV === 'development' ? '' : (process.env.REACT_APP_API_URL || 'http://3.111.187.235:8080');

const EMPTY_FORM = { name: '', email: '', phone: '', address: '', message: '' };

const onlineImages = [groupOnline1, groupOnline2, groupOnline3, groupOnline4];
const physicalImages = [
  groupPhysical1, groupPhysical2, groupPhysical3, groupPhysical4, groupPhysical5,
  groupPhysical6, groupPhysical7, groupPhysical8, groupPhysical9, groupPhysical10,
  groupPhysical11, groupPhysical12, groupPhysical13
];

const MH_MAJOR_CITIES = [
  "Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Navi Mumbai", "Pimpri-Chinchwad",
  "Kalyan-Dombivli", "Vasai-Virar", "Chhatrapati Sambhajinagar", "Solapur", "Kolhapur",
  "Amravati", "Nanded", "Sangli", "Jalgaon", "Akola", "Latur", "Dhule", "Ahmednagar",
  "Chandrapur", "Parbhani", "Jalna", "Beed", "Gondia", "Satara", "Yavatmal", "Wardha",
  "Bhandara", "Ratnagiri", "Sindhudurg", "Osmanabad", "Nandurbar", "Panvel", "Bhiwandi", "Malegaon"
];

const getCellImage = (name, id, location) => {
  const loc = (location || '').toLowerCase();
  const cellName = (name || '').toLowerCase();
  
  // Identify if cell is online/virtual
  const isOnline = loc.includes('online') || loc.includes('virtual') || cellName.includes('online');
  
  if (isOnline) {
    if (cellName.includes('zoe 1')) return groupOnline1;
    if (cellName.includes('perfection')) return groupOnline2;
    if (cellName.includes('zoe 2')) return groupOnline3;
    if (cellName.includes('logos')) return groupOnline4;
    return onlineImages[(id || 0) % onlineImages.length];
  } else {
    if (cellName.includes('favor') && !cellName.includes('favour')) return groupPhysical1;
    if (cellName.includes('seed of light')) return groupPhysical2;
    if (cellName.includes('rehaboth')) return groupPhysical3;
    if (cellName.includes('huios')) return groupPhysical4;
    if (cellName.includes('favour')) return groupPhysical5;
    if (cellName.includes('zoe 4')) return groupPhysical6;
    if (cellName.includes('ablaze')) return groupPhysical7;
    if (cellName.includes('living water')) return groupPhysical8;
    if (cellName.includes('zoe 6')) return groupPhysical9;
    if (cellName.includes('truevine')) return groupPhysical10;
    if (cellName.includes('new beginning')) return groupPhysical11;
        if (cellName.includes('dynamic')) return groupPhysical12;
    if (cellName.includes('genesis')) return groupPhysical13;
    
    return physicalImages[(id || 0) % physicalImages.length];
  }
};

const INITIAL_CELLS = [
  { id: 1, name: "ZOE 1", leaderName: "PASTOR NANCY MATHEW", phoneNumber: "86003 40609", location: "Online", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "A vibrant online community focused on Word-based fellowship." },
  { id: 2, name: "GODS SEED OF LIGHT-1", leaderName: "SIS UMA TIMMAYA", phoneNumber: "8888976703", location: "Keshavnagar, BT Kawade road, Magarpatta", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "Nurturing the seed of God's Word in our hearts." },
  { id: 3, name: "REHABOTH", leaderName: "BRO RAKESH KALE", phoneNumber: "98819 88420", location: "Hadapsar", state: "MH", city: "Pune", meetingTime: "Sundays, 4:00 PM", description: "A place of enlargement and prosperity." },
  { id: 4, name: "HUIOS", leaderName: "BRO ABHISHEK BANSODE", phoneNumber: "9822670500", location: "Undri", state: "MH", city: "Pune", meetingTime: "Fridays, 7:00 PM", description: "Sons of God manifesting His glory." },
  { id: 5, name: "FAVOUR 1", leaderName: "CELINA BANKAR", phoneNumber: "9067926001", location: "Wanowrie", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "Walking in the unmerited favor of God." },
  { id: 6, name: "ZOE 4", leaderName: "SIS SHOMA", phoneNumber: "85271 39450", location: "Bhugaon", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "Experiencing the life of God in its fullness." },
  { id: 7, name: "ABLAZE", leaderName: "SIS JOYCE CHIFITAH", phoneNumber: "260 978540835", location: "Keshavnagar", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:30 PM", description: "Setting our community on fire for Christ." },
  { id: 8, name: "ZOE 6", leaderName: "PASTOR NANCY MATHEW", phoneNumber: "86003 40609", location: "Kharadi", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "Spreading the gospel in the heart of Kharadi." },
  { id: 9, name: "TRUEVINE", leaderName: "SIS JOANNA EPHREM", phoneNumber: "7758991652", location: "Pune", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "Abiding in the Vine to bear much fruit." },
  { id: 10, name: "NEW BEGINNING", leaderName: "SIS POONAM TRIBHUVAN", phoneNumber: "9373352622", location: "Undri", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "Start your journey of faith with us." },
  { id: 11, name: "EXPANSION", leaderName: "SIS VAISHALI BANSODE", phoneNumber: "9172608834", location: "Pune", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "Stretching forth to reach more souls." },
  { id: 12, name: "VICTORY 1", leaderName: "SIS PAULINE FERNANDES", phoneNumber: "97302 27771", location: "Shop Vadgaon Sheri", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "Walking in victory every day." },
  { id: 13, name: "DUNAMIS", leaderName: "BRO MANISH DALVI", phoneNumber: "7972721237", location: "Chandan Nagar", state: "MH", city: "Pune", meetingTime: "Fridays, 7:00 PM", description: "Experiencing the power of the Holy Spirit." },
  { id: 14, name: "EXCELLENCE", leaderName: "BRO PRASHANT BANSODE", phoneNumber: "9766745276", location: "Lonikalbhor, Pune", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "A culture of excellence in all we do." },
  { id: 15, name: "DYNAMIC 1", leaderName: "BRO ANIKET CHANDANSHIV", phoneNumber: "9960504903", location: "Hadapsar", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "A dynamic fellowship of Spirit-filled believers." },
  { id: 16, name: "DYNAMIC 2", leaderName: "BRO ANIKET CHANDANSHIV", phoneNumber: "9960504903", location: "Wadgaon sheri", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:30 PM", description: "Active and growing in the things of God." },
  { id: 17, name: "GENESIS 1", leaderName: "BRO ROHIT", phoneNumber: "8788236598", location: "Ghorpadi", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "Beginning a new era of spiritual dominance." },
  { id: 18, name: "PEACEFUL", leaderName: "SIS SONIA", phoneNumber: "95797 24504", location: "Kondhwa", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "Experiencing the peace that passes all understanding." },
  { id: 19, name: "GREAT HARVEST", leaderName: "SIS RUPALI TAMBE", phoneNumber: "8080100958", location: "Pimpri", state: "MH", city: "Pimpri-Chinchwad", meetingTime: "Saturdays, 6:00 PM", description: "Bringing in the harvest of souls." },
  { id: 20, name: "REDEMPTION", leaderName: "PASTOR MILIND TAMBE", phoneNumber: "9850856183", location: "Pimpri", state: "MH", city: "Pimpri-Chinchwad", meetingTime: "Fridays, 7:00 PM", description: "Redeemed by the blood of the Lamb." },
  { id: 21, name: "DECLARATION", leaderName: "BRO AMOL MUGUMAL", phoneNumber: "", location: "Pimpri", state: "MH", city: "Pimpri-Chinchwad", meetingTime: "Saturdays, 6:00 PM", description: "Declaring the Word of God." },
  { id: 22, name: "MANISHA SUKHWANI CELL", leaderName: "SIS MANISHA SUKHWANI", phoneNumber: "9021423377", location: "Pimpri", state: "MH", city: "Pimpri-Chinchwad", meetingTime: "Saturdays, 6:00 PM", description: "Fellowship cell in Pimpri." },
  { id: 23, name: "THE PROLIFIC", leaderName: "BR ISHAN", phoneNumber: "7030770060", location: "Pimple Gurav", state: "MH", city: "Pimpri-Chinchwad", meetingTime: "Saturdays, 5:00 PM", description: "Bearing fruit in every season." },
  { id: 24, name: "RADIANCE 1", leaderName: "PST PARAG SURYWANSHI", phoneNumber: "9890511102", location: "Pune", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "Shining the light of the gospel." },
  { id: 25, name: "CHARIS 1", leaderName: "SIS LAM NAIK", phoneNumber: "9975677661", location: "Kondhwa", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:30 PM", description: "Living in the abundance of God's grace." },
  { id: 26, name: "DUNAMIS 1", leaderName: "SIS REKHA FERNADES", phoneNumber: "8605116220", location: "Manjari", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "Walking in power and authority." },
  { id: 27, name: "SAMRUDHI CELL 1", leaderName: "SIS SAVITA KADAM", phoneNumber: "83088 72140", location: "Wabori, Nagar", state: "MH", city: "Ahmednagar", meetingTime: "Saturdays, 5:00 PM", description: "Prospering in all areas of life." },
  { id: 28, name: "GRACE-01", leaderName: "SIS SAVITA", phoneNumber: "8010566833", location: "Vaiduwadi", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:30 PM", description: "Abounding in grace and love." },
  { id: 29, name: "MAHIMA-01", leaderName: "SIS NEHA", phoneNumber: "7058613795", location: "Khole Vasti", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "Displaying the glory of God." },
  { id: 30, name: "GODS SEED OF LIGHT-2", leaderName: "SIS UMA TIMMAYA", phoneNumber: "8888976703", location: "Keshavnagar, BT Kawade road, Magarpatta", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 31, name: "GODS SEED OF LIGHT-3", leaderName: "SIS UMA TIMMAYA", phoneNumber: "8888976703", location: "Keshavnagar, BT Kawade road, Magarpatta", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 32, name: "GODS SEED OF LIGHT-4", leaderName: "SIS UMA TIMMAYA", phoneNumber: "8888976703", location: "Keshavnagar, BT Kawade road, Magarpatta", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 33, name: "GODS SEED OF LIGHT-5", leaderName: "SIS UMA TIMMAYA", phoneNumber: "8888976703", location: "Keshavnagar, BT Kawade road, Magarpatta", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 34, name: "ZOE 3", leaderName: "BRO RAKESH KALE", phoneNumber: "98819 88420", location: "-", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 35, name: "ZOE 5", leaderName: "SIS SHOMA", phoneNumber: "85271 39450", location: "Bhugaon", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "" },
  { id: 36, name: "UNNAMED CELL", leaderName: "SIS REYNAH", phoneNumber: "", location: "", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 37, name: "VICTORY 2", leaderName: "SIS PAULINE FERNANDES", phoneNumber: "97302 27771", location: "Online", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "" },
  { id: 38, name: "VICTORY 3", leaderName: "SIS PAULINE FERNANDES", phoneNumber: "97302 27771", location: "Online", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "" },
  { id: 39, name: "VICTORY 4", leaderName: "SIS PAULINE FERNANDES", phoneNumber: "97302 27771", location: "Online", state: "MH", city: "Pune", meetingTime: "Saturdays, 6:00 PM", description: "" },
  { id: 40, name: "DUNAMIS", leaderName: "BRO JOSHUA BANSODE", phoneNumber: "9172608834", location: "Ghorpadi & Keshavnagar", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 41, name: "I GOT JOY", leaderName: "SIS POONAM TRIBHUVAN", phoneNumber: "9373352622", location: "Yerawada", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 42, name: "SHALOM", leaderName: "SIS SANGEETA BANKAR", phoneNumber: "9021112647", location: "Pimpri", state: "MH", city: "Pimpri-Chinchwad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 43, name: "DYNAMIC 3", leaderName: "BRO ANIKET CHANDANSHIV", phoneNumber: "9960504903", location: "Online?", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 44, name: "DYNAMIC 4", leaderName: "SIS DIPALI", phoneNumber: "9960504903", location: "Wadgaon Sheri", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 45, name: "DYNAMIC 5", leaderName: "SIS DIPALI", phoneNumber: "9960504903", location: "Wadgaon Sheri", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 46, name: "DYNAMIC 6", leaderName: "SIS TRUPTI", phoneNumber: "9960504903", location: "Hadapsar", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 47, name: "DYNAMIC 7", leaderName: "SIS SHEETAL", phoneNumber: "9284110679", location: "Hadapsar", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 48, name: "MEGA 2", leaderName: "SIS HIMANI MUKKHAII", phoneNumber: "8788236598", location: "X", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 49, name: "GENESIS 2", leaderName: "BRO ROHIT", phoneNumber: "8788236598", location: "New Mulawe", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 50, name: "GENESIS 3", leaderName: "BRO ROHIT", phoneNumber: "8788236598", location: "Pimple Gurav", state: "MH", city: "Pimpri-Chinchwad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 51, name: "GENESIS 4", leaderName: "BRO ROHIT", phoneNumber: "8788236598", location: "Wagholi", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 52, name: "GENESIS 5", leaderName: "BRO ROHIT", phoneNumber: "8788236598", location: "Bhosari", state: "MH", city: "Pimpri-Chinchwad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 53, name: "GENESIS 6", leaderName: "BRO ROHIT", phoneNumber: "8788236598", location: "Alandi", state: "MH", city: "Pimpri-Chinchwad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 54, name: "GENESIS 7", leaderName: "BRO ROHIT", phoneNumber: "8788236598", location: "Keshv Nagar", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 55, name: "GENESIS 8", leaderName: "BRO AVINASH KAMBLE", phoneNumber: "8788236598", location: "Ghorawadi - Wagholi", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 56, name: "GENESIS 9", leaderName: "SIS ASMITA", phoneNumber: "8788236598", location: "Near G mail - Manjari", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 57, name: "GENESIS 10", leaderName: "BRO SACHIN", phoneNumber: "8788236598", location: "Khadki", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 58, name: "GENESIS 11", leaderName: "BRO SACHIN", phoneNumber: "8788236598", location: "Ambegaon", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 59, name: "GENESIS 12", leaderName: "BRO SACHIN", phoneNumber: "8788236598", location: "Wadgaon sheri", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 60, name: "GENESIS TEEVO", leaderName: "SIS ATHASHREE", phoneNumber: "81779 03346", location: "Shewalewadi", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 61, name: "REJOICE", leaderName: "SIS PRISCILLA", phoneNumber: "9209608561", location: "X", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 62, name: "FAVOR & FAVOR ALWAYS", leaderName: "SIS SNEHA RAVI", phoneNumber: "", location: "Keshavnagar", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 63, name: "GREATER GRACE", leaderName: "SIS ARPNA", phoneNumber: "", location: "Shivneri?", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 64, name: "DUNAMIS 2", leaderName: "SIS REKHA FERNADES", phoneNumber: "8605116220", location: "Manjari", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 65, name: "DUNAMIS 3", leaderName: "SIS BABITA", phoneNumber: "", location: "Manjari", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 66, name: "SAMRUDHI CELL 2", leaderName: "SIS SAVITA KADAM", phoneNumber: "83088 72140", location: "Malegaon, Sangamner", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 67, name: "SAMRUDHI CELL 3", leaderName: "SIS SAVITA KADAM", phoneNumber: "83088 72140", location: "Nagar City", state: "MH", city: "Ahmednagar", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 68, name: "SAMRUDHI CELL 4", leaderName: "SIS SAVITA KADAM", phoneNumber: "83088 72140", location: "Takarabad", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 69, name: "GOD'S GRACE", leaderName: "DCNS VAISHALI FRANCIS", phoneNumber: "", location: "", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 70, name: "GRACE-02", leaderName: "SIS SAVITA", phoneNumber: "8010566833", location: "Jaysingpur", state: "MH", city: "Kolhapur", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 71, name: "MAHIMA-02", leaderName: "SIS NEHA", phoneNumber: "7058613795", location: "Jamkhed Vasti", state: "MH", city: "Beed", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 72, name: "MAHIMA-03", leaderName: "SIS NEHA", phoneNumber: "7058613795", location: "Toranwade Vasti", state: "MH", city: "Beed", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 73, name: "MAHIMA-04", leaderName: "SIS NEHA", phoneNumber: "7058613795", location: "Beed", state: "MH", city: "Beed", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 74, name: "DIVINE", leaderName: "SIS SUNANDA SASANE", phoneNumber: "8356883011", location: "Shrirampur", state: "MH", city: "Ahmednagar", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 75, name: "PHRONESIS CELL 1", leaderName: "BRO ANDINDILILE", phoneNumber: "9266513954", location: "Deepliving GR, UP", state: "UP", city: "Greater Noida", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 76, name: "PHRONESIS CELL 2", leaderName: "SIS JACQUELINE", phoneNumber: "88265 78474", location: "", state: "UP", city: "Greater Noida", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 77, name: "PHRONESIS CELL 3", leaderName: "SIS JEMIMA", phoneNumber: "9289735078", location: "Online", state: "UP", city: "Greater Noida", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 78, name: "PHRONESIS CELL 4", leaderName: "BRO CALVIN", phoneNumber: "9773979934", location: "Online", state: "UP", city: "Greater Noida", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 79, name: "ABUNDANCE CELL", leaderName: "SIS SHIDAT", phoneNumber: "7630024645", location: "Casa Grande 1, GR, UP", state: "UP", city: "Greater Noida", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 80, name: "GLORIOUS CELL", leaderName: "SIS DOREEN", phoneNumber: "93116 88738", location: "", state: "UP", city: "Greater Noida", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 81, name: "GLORY CELL 1", leaderName: "SIS JACQUELINE", phoneNumber: "88265 78474", location: "Qube Studios Habitech, GR, UP", state: "UP", city: "Greater Noida", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 82, name: "GLORY CELL 2", leaderName: "SIS RECIDA", phoneNumber: "9599223756", location: "Supertech Upcountry, GR, UP", state: "UP", city: "Greater Noida", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 83, name: "MIMSHACH CELL 1", leaderName: "SIS FLORENCE", phoneNumber: "", location: "Vadodara Gujarat", state: "GJ", city: "Vadodara", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 84, name: "MIMSHACH CELL 2", leaderName: "BRO WISDOM", phoneNumber: "89746 96860", location: "Faridabad, Delhi", state: "HR", city: "Faridabad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 85, name: "MIMSHACH-5", leaderName: "Sis Brenda nambi", phoneNumber: "955757635", location: "auditorium school campus Graphic era university", state: "UT", city: "Dehradun", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 86, name: "MIMSHACH-6", leaderName: "SIS Veronica Mulanda", phoneNumber: "8360304134", location: "school campus Graphic Era university", state: "UT", city: "Dehradun", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 87, name: "MIMSHACH-7", leaderName: "SIS Sarah Amongi", phoneNumber: "", location: "Graphic Era university campus Graphic", state: "UT", city: "Dehradun", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 88, name: "PERFECTION", leaderName: "SIS TSHIDY", phoneNumber: "9520604791", location: "Mother Teresa hostel Dehradun Uttarakhand", state: "UT", city: "Dehradun", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 89, name: "PHOSTER CELL", leaderName: "Sis Ruth Kwagala", phoneNumber: "9520602684", location: "Graphic Era university campus", state: "UT", city: "Dehradun", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 90, name: "IMPACT", leaderName: "SIS PRISCILLA", phoneNumber: "9030760434", location: "Haneef Colony, New Hafeezpet, Hyderabad", state: "TG", city: "Hyderabad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 91, name: "LIGHT", leaderName: "SIS MONIKA DEBORAH", phoneNumber: "9100462052", location: "Prem nagar, New hafeezpet, Hyderabad", state: "TG", city: "Hyderabad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 92, name: "RHEMA", leaderName: "SIS MERCY", phoneNumber: "9030498230", location: "Prem nagar, New hafeezpet, Hyderabad", state: "TG", city: "Hyderabad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 93, name: "BLOSSOM", leaderName: "BR JONATHAN", phoneNumber: "9866760561", location: "Prem nagar, New hafeezpet, Hyderabad", state: "TG", city: "Hyderabad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 94, name: "PROLIFIC BELIVERS", leaderName: "SIS GLORY", phoneNumber: "", location: "Prashant Nagar, Kondapur, Hyderabad", state: "TG", city: "Hyderabad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 95, name: "THE PRAYER", leaderName: "BR JONATHAN", phoneNumber: "9866760561", location: "Prem nagar, New hafeezpet, Hyderabad", state: "TG", city: "Hyderabad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 96, name: "GATHERING CLOUDS", leaderName: "BRO CHARLES", phoneNumber: "9502422665", location: "New Hafeezpet, Hyderabad", state: "TG", city: "Hyderabad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 97, name: "THE JOY", leaderName: "BRO ANDREW", phoneNumber: "", location: "Siddipet, Telangana", state: "TG", city: "Siddipet", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 98, name: "IGNITING SPIRITS", leaderName: "SIS GLORY", phoneNumber: "", location: "Prashant Nagar, Kondapur, Hyderabad", state: "TG", city: "Hyderabad", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 99, name: "KABHOSH", leaderName: "Sis Preeti", phoneNumber: "", location: "Siddipet, Telangana", state: "TG", city: "Siddipet", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 100, name: "SHINING FOR CHRIST", leaderName: "SIS ROSEY", phoneNumber: "", location: "Online", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 101, name: "BERACHAH", leaderName: "BRO ZOE", phoneNumber: "8367543025", location: "Gowrishankar Nagar", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 102, name: "MIRACLE", leaderName: "SIS JYOTI", phoneNumber: "", location: "ONLINE CELL MEETING", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 103, name: "HIGHLY PROLIFIC", leaderName: "BRO LEVI BHARATH KUMAR", phoneNumber: "", location: "Sundhariah colony", state: "MH", city: "Pune", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 104, name: "HENOTES", leaderName: "SIS DR ANITA LYDIA", phoneNumber: "98869 73868", location: "Karungal", state: "TN", city: "Karungal", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 105, name: "MERCY", leaderName: "V.J.OSWALD NEWTON", phoneNumber: "9488941999", location: "ZION NAGAR", state: "TN", city: "Kanyakumari", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 106, name: "GRACE", leaderName: "VIJI KUMAR", phoneNumber: "96773 42375", location: "MIDALAM", state: "TN", city: "Midalam", meetingTime: "Saturdays, 5:00 PM", description: "" },
  { id: 107, name: "RAPHA", leaderName: "JASBIN CHRISTOPHER", phoneNumber: "8526042416", location: "THISAYANVILAI", state: "TN", city: "Thisayanvilai", meetingTime: "Saturdays, 5:00 PM", description: "" }
].map((cell) => ({ ...cell, image: getCellImage(cell.name, cell.id, cell.location) }));


const FellowshipLocator = () => {
  const [searchQuery, setSearchQuery]   = useState('');
  const [allCells, setAllCells]         = useState(INITIAL_CELLS);
  const [filteredCells, setFilteredCells] = useState(INITIAL_CELLS);
  const [selectedCell, setSelectedCell] = useState(null);
  const [form, setForm]                 = useState(EMPTY_FORM);
  const [formState, setFormState]       = useState('idle'); // idle | loading | success | error
  const modalRef = useRef(null);

  // Filter states
  const [selectedCategory, setSelectedCategory] = useState(''); // 'Physical', 'Online', ''
  const [selectedStateCode, setSelectedStateCode] = useState('');
  const [selectedCity, setSelectedCity] = useState('');

  const ALLOWED_LOCATIONS = useMemo(() => ({
    "MH": { name: "Maharashtra", cities: ["Pune", "Pimpri-Chinchwad", "Ahmednagar"] },
    "TG": { name: "Telangana", cities: ["Hyderabad", "Siddipet"] },
    "GA": { name: "Goa", cities: ["Goa"] },
    "UP": { name: "Uttar Pradesh", cities: ["Greater Noida"] },
    "HR": { name: "Haryana", cities: ["Faridabad"] },
    "GJ": { name: "Gujarat", cities: ["Vadodara"] },
    "TN": { name: "Tamil Nadu", cities: ["Kanyakumari", "Karungal", "Midalam", "Thisayanvilai"] },
    "UT": { name: "Uttarakhand", cities: ["Dehradun"] }
  }), []);

  const indianStates = useMemo(() => {
    return Object.entries(ALLOWED_LOCATIONS).map(([isoCode, data]) => ({
      isoCode,
      name: data.name
    }));
  }, [ALLOWED_LOCATIONS]);

  const availableCities = useMemo(() => {
    if (selectedStateCode && ALLOWED_LOCATIONS[selectedStateCode]) {
      return ALLOWED_LOCATIONS[selectedStateCode].cities;
    }
    return Object.values(ALLOWED_LOCATIONS).flatMap(data => data.cities).sort();
  }, [selectedStateCode, ALLOWED_LOCATIONS]);

  const [expandedStates, setExpandedStates] = useState({});
  const [expandedCities, setExpandedCities] = useState({});

  const toggleState = (state) => setExpandedStates(prev => ({ ...prev, [state]: !prev[state] }));
  const toggleCity = (cityKey) => setExpandedCities(prev => ({ ...prev, [cityKey]: !prev[cityKey] }));
  // Grouped cells for the accordion
  const groupedCells = useMemo(() => {
    const groups = {};
    filteredCells.forEach(cell => {
      // Fix: Filter out cells that don't have a valid state and city to avoid 'OTHER' group
      if (!cell.state || !cell.city) return;
      
      const stateName = indianStates.find(s => s.isoCode === cell.state)?.name || cell.state;
      const cityName = cell.city;
      
      if (!groups[stateName]) groups[stateName] = {};
      if (!groups[stateName][cityName]) groups[stateName][cityName] = [];
      groups[stateName][cityName].push(cell);
    });
    return groups;
  }, [filteredCells, indianStates]);

  // Auto-expand all states and cities whenever the groups change
  useEffect(() => {
    const newExpandedStates = {};
    const newExpandedCities = {};
    Object.keys(groupedCells).forEach(stateName => {
      newExpandedStates[stateName] = true;
      Object.keys(groupedCells[stateName]).forEach(cityName => {
        newExpandedCities[`${stateName}-${cityName}`] = true;
      });
    });
    setExpandedStates(newExpandedStates);
    setExpandedCities(newExpandedCities);
  }, [groupedCells]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchFellowships();
  }, []);
  const fetchFellowships = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/fellowships`);
      if (res.ok) {
        const data = await res.json();
        if (data && data.length > 0) {
          const enrichedData = data.map((cell) => {
            const initialCell = INITIAL_CELLS.find(ic => ic.name === cell.name) || {};
            let state = cell.state || initialCell.state || 'MH';
            let city = cell.city || initialCell.city || 'Pune';
            
            if (city === 'Greater Noida') state = 'UP';
            if (city === 'Faridabad') state = 'HR';
            if (city === 'Vadodara') state = 'GJ';
            
            return {
              ...cell,
              state: state,
              city: city,
              image: getCellImage(cell.name, cell.id, cell.location),
            };
          });
          setAllCells(enrichedData);
          setFilteredCells(enrichedData);
        }
      }
    } catch (error) {
      console.error('Error in fetchFellowships:', error);
    }
  };

  // Close modal on outside click
  useEffect(() => {
    if (!selectedCell) return;
    const handler = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) closeModal();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [selectedCell]);

  // Prevent body scroll when modal open
  useEffect(() => {
    document.body.style.overflow = selectedCell ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [selectedCell]);

  // Function to apply all filters
  const applyFilters = (query, category, stateCode, city) => {
    let filtered = allCells;

    if (query) {
      const lowerQ = query.toLowerCase();
      filtered = filtered.filter(c =>
        (c.location && c.location.toLowerCase().includes(lowerQ)) ||
        (c.name && c.name.toLowerCase().includes(lowerQ)) ||
        (c.leaderName && c.leaderName.toLowerCase().includes(lowerQ))
      );
    }

    if (category) {
      if (category === 'Online') {
        filtered = filtered.filter(c => {
          const loc = (c.location || '').toLowerCase();
          const name = (c.name || '').toLowerCase();
          return loc.includes('online') || loc.includes('virtual') || name.includes('online');
        });
      } else if (category === 'Physical') {
        filtered = filtered.filter(c => {
          const loc = (c.location || '').toLowerCase();
          const name = (c.name || '').toLowerCase();
          return !(loc.includes('online') || loc.includes('virtual') || name.includes('online'));
        });
      }
    }

    if (stateCode) {
      filtered = filtered.filter(c => {
        if (c.state === stateCode) return true;
        if (!c.state && stateCode === 'MH') {
          const loc = (c.location || '').toLowerCase();
          return loc.includes('pune') || loc.includes('hadapsar') || loc.includes('kharadi') || loc.includes('undri') || loc.includes('wanowrie') || loc.includes('bhugaon') || loc.includes('keshavnagar') || loc.includes('vishrantwadi') || loc.includes('ghorpadi') || loc.includes('akurdi') || loc.includes('online') || loc.includes('virtual');
        }
        return false;
      });
    }

    if (city) {
      filtered = filtered.filter(c => c.city === city);
    }

    setFilteredCells(filtered);
  };

  const handleSearch = (e) => {
    const q = e.target.value;
    setSearchQuery(q);
    applyFilters(q, selectedCategory, selectedStateCode, selectedCity);
  };

  const handleCategoryChange = (e) => {
    const cat = e.target.value;
    setSelectedCategory(cat);
    applyFilters(searchQuery, cat, selectedStateCode, selectedCity);
  };

  const handleStateChange = (e) => {
    const stateCode = e.target.value;
    setSelectedStateCode(stateCode);
    setSelectedCity(''); // Reset city when state changes
    applyFilters(searchQuery, selectedCategory, stateCode, ''); // Pass empty city

    // Auto-expand state in accordion
    if (stateCode) {
      const stateName = indianStates.find(s => s.isoCode === stateCode)?.name || stateCode;
      setExpandedStates(prev => ({ ...prev, [stateName]: true }));
    }
  };

  const handleCityChange = (e) => {
    const city = e.target.value;
    setSelectedCity(city);
    applyFilters(searchQuery, selectedCategory, selectedStateCode, city);
    
    // Auto-expand state and city in accordion
    if (selectedStateCode && city) {
      const stateName = indianStates.find(s => s.isoCode === selectedStateCode)?.name || selectedStateCode;
      setExpandedStates(prev => ({ ...prev, [stateName]: true }));
      setExpandedCities(prev => ({ ...prev, [`${stateName}-${city}`]: true }));
    }
  };

  const openModal  = (cell) => { setSelectedCell(cell); setForm(EMPTY_FORM); setFormState('idle'); };
  const closeModal = ()     => { setSelectedCell(null); setFormState('idle'); };

  const handleFormChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone) return;
    setFormState('loading');

    try {
      const res = await fetch(`${API_BASE}/api/fellowships/${selectedCell.id}/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          cellId:      selectedCell.id,
          cellName:    selectedCell.name,
          leaderEmail: selectedCell.leaderEmail,
        }),
      });

      if (res.ok) {
        setFormState('success');
      } else {
        setFormState('error');
      }
    } catch {
      setFormState('error');
    }
  };

  return (
    <>
      <Navbar />
      <div className="fellowships-page">

        {/* Blobs */}
        <div className="hero-blob blob-1" />
        <div className="hero-blob blob-2" />

        {/* Hero */}
        <div className="fellowships-hero">
          <div className="hero-people-container">
            <img
              src="/assets/images/fellowship_3d_group.png"
              alt=""
              className="hero-people-img"
              fetchpriority="high"
              decoding="async"
            />
          </div>
          <div className="fellowships-hero-content">
            <p className="fl-eyebrow">Cell Fellowships · Pune</p>
            <h1 className="hero-main-title">FIND YOUR <span>COMMUNITY</span></h1>
            <p className="hero-subtitle">
              Join a vibrant community of believers, growing in the Word together across Pune.
            </p>
            <div className="search-box-centered">
              <div className="search-inner">
                <span className="search-icon-glass">🔍</span>
                <input
                  type="text"
                  placeholder="Search by area or cell name…"
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>
            </div>

            <div className="fl-portal-banner">
              <a 
                href="https://ceinz2.vercel.app/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="fl-portal-btn"
              >
                For more cell detail, check out the CHRIST EMBASSY INDIA ZONE 2 · CELL MINISTRY PORTAL
              </a>
            </div>
          </div>
        </div>

        {/* Cards */}
        <div className="fellowships-content">
          <div className="section-header">
            <div className="sh-label">
              <span className="eyebrow">Cell Groups</span>
            </div>
            <div className="sh-title">
              <h2 className="section-title">
                {filteredCells.length > 0
                  ? searchQuery ? `Fellowships near "${searchQuery}"` : 'Fellowships in Pune'
                  : 'No fellowships found in that area'}
              </h2>
            </div>
          </div>

          <div className="fl-filters-container">
            <div className="fl-filter-group">
              <label>Category</label>
              <select value={selectedCategory} onChange={handleCategoryChange} className="fl-filter-select">
                <option value="">All Fellowships</option>
                <option value="Physical">Physical / In-Person</option>
                <option value="Online">Online / Virtual</option>
              </select>
            </div>
            <div className="fl-filter-group">
              <label>State (India)</label>
              <select value={selectedStateCode} onChange={handleStateChange} className="fl-filter-select">
                <option value="">All States</option>
                {indianStates.map(state => (
                  <option key={state.isoCode} value={state.isoCode}>{state.name}</option>
                ))}
              </select>
            </div>
            <div className="fl-filter-group">
              <label>City</label>
              <select value={selectedCity} onChange={handleCityChange} className="fl-filter-select">
                <option value="">All Cities</option>
                {availableCities.map(city => (
                  <option key={city} value={city}>{city}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="cells-grouped-container">
            {Object.keys(groupedCells).length === 0 ? (
               <div className="no-results">No fellowships found.</div>
            ) : (
              Object.keys(groupedCells).sort().map(stateName => (
                <div key={stateName} className="fl-group-state">
                  <div 
                    className="fl-group-state-header" 
                    onClick={() => toggleState(stateName)}
                  >
                    <h3>{stateName}</h3>
                    <span className="fl-group-icon">
                      {expandedStates[stateName] ? '▼' : '►'}
                    </span>
                  </div>
                  
                  {expandedStates[stateName] && (
                    <div className="fl-group-state-content">
                      {Object.keys(groupedCells[stateName]).sort().map(cityName => (
                        <div key={cityName} className="fl-group-city">
                          <div 
                            className="fl-group-city-header"
                            onClick={() => toggleCity(`${stateName}-${cityName}`)}
                          >
                            <h4>{cityName}</h4>
                            <span className="fl-group-icon">
                              {expandedCities[`${stateName}-${cityName}`] ? '▼' : '►'}
                            </span>
                          </div>
                          
                          {expandedCities[`${stateName}-${cityName}`] && (
                            <div className="cells-grid">
                              {groupedCells[stateName][cityName].map(cell => (
                                <div key={cell.id} className="cell-card" onClick={() => openModal(cell)}>
                                  <div className="cell-image-container">
                                    <img src={cell.image} alt={cell.name} className="cell-image" loading="lazy" decoding="async" />
                                  </div>
                                  <div className="cell-details">
                                    <h3 className="cell-name">{cell.name}</h3>
                                    <p className="cell-meta">{cell.location}</p>
                                    <p className="cell-meta"><span className="meta-icon">🕒</span>{cell.meetingTime}</p>
                                    <div className="cell-join-hint">
                                      <span>Join group</span>
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <line x1="5" y1="12" x2="19" y2="12" />
                                        <polyline points="12 5 19 12 12 19" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>

        {/* ── Join Modal ── */}
        {selectedCell && (
          <div className="fl-modal-backdrop">
            <div className="fl-modal" ref={modalRef} role="dialog" aria-modal="true">

              {/* Close */}
              <button className="fl-modal-close" onClick={closeModal} aria-label="Close">✕</button>

              {formState === 'success' ? (
                <div className="fl-success">
                  <div className="fl-success-icon">✓</div>
                  <h3>Request Submitted!</h3>
                  <p>
                    Thanks, <strong>{form.name}</strong>! Your request to join{' '}
                    <strong>{selectedCell.name}</strong> has been received.
                    You'll be notified once your seat is confirmed.
                  </p>
                  <button className="fl-btn-primary" onClick={closeModal}>Done</button>
                </div>
              ) : (
                <>
                  {/* Cell info strip */}
                  <div className="fl-cell-info">
                    <img src={selectedCell.image} alt={selectedCell.name} className="fl-cell-thumb" />
                    <div>
                      <h3 className="fl-cell-title">{selectedCell.name}</h3>
                      <p className="fl-cell-desc">{selectedCell.description}</p>
                      <div className="fl-cell-meta-row">
                        <span>{selectedCell.location}</span>
                        <span><span className="meta-icon">🕒</span>{selectedCell.meetingTime}</span>
                      </div>
                    </div>
                  </div>

                  <div className="fl-divider" />

                  {/* Form */}
                  <h4 className="fl-form-heading">Request to Join</h4>
                  <form className="fl-form" onSubmit={handleSubmit} noValidate>
                    <div className="fl-form-row">
                      <div className="fl-field">
                        <label>Full Name <span className="req">*</span></label>
                        <input
                          name="name" type="text"
                          placeholder="Your full name"
                          value={form.name}
                          onChange={handleFormChange}
                          required
                        />
                      </div>
                      <div className="fl-field">
                        <label>Email Address <span className="req">*</span></label>
                        <input
                          name="email" type="email"
                          placeholder="you@email.com"
                          value={form.email}
                          onChange={handleFormChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="fl-form-row">
                      <div className="fl-field">
                        <label>Phone Number <span className="req">*</span></label>
                        <input
                          name="phone" type="tel"
                          placeholder="+91 98765 43210"
                          value={form.phone}
                          onChange={handleFormChange}
                          required
                        />
                      </div>
                      <div className="fl-field">
                        <label>Your Area / Locality</label>
                        <input
                          name="address" type="text"
                          placeholder="e.g. Kharadi, Viman Nagar"
                          value={form.address}
                          onChange={handleFormChange}
                        />
                      </div>
                    </div>

                    <div className="fl-field fl-field--full">
                      <label>Message (optional)</label>
                      <textarea
                        name="message"
                        placeholder="Any questions or message for the cell leader…"
                        value={form.message}
                        onChange={handleFormChange}
                        rows={3}
                      />
                    </div>

                    {formState === 'error' && (
                      <p className="fl-error-msg">Something went wrong. Please try again.</p>
                    )}

                    <div className="fl-form-footer">
                      <p className="fl-disclaimer">
                        Your details will be shared with the cell leader who will confirm your seat.
                      </p>
                      <button
                        type="submit"
                        className="fl-btn-primary"
                        disabled={formState === 'loading'}
                      >
                        {formState === 'loading'
                          ? <span className="fl-spin" />
                          : 'Submit Request'}
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default FellowshipLocator;